import { DB_NAME, DB_VERSION } from '../../../libraries/storage/constants';
import { initDB } from '../../../libraries/storage/idb';
import { IDB_STORE_JOURNAL } from './constants';
import type { JournalEntry } from './types';
export async function readJournalEntries(taskID: string, limit: number): Promise<JournalEntry[]> {
  const db = await openDb();
  try {
    return await new Promise<JournalEntry[]>((resolve, reject) => {
      const tx = db.transaction(IDB_STORE_JOURNAL, 'readonly');
      const store = tx.objectStore(IDB_STORE_JOURNAL);
      const index = store.index('taskID');
      const results: JournalEntry[] = [];
      const request = index.openCursor(IDBKeyRange.only(taskID));
      request.onsuccess = () => {
        const cursor = request.result;
        if (!cursor || results.length >= limit) {
          resolve(results);
          return;
        }
        results.push((cursor.value as JournalEntry));
        cursor.continue();
      };
      request.onerror = () => reject(request.error);
    });
  } finally {
    db.close();
  }
}
export async function deleteJournalEntries(sequences: number[]): Promise<void> {
  if (sequences.length === 0) return;
  const db = await openDb();
  try {
    return await new Promise<void>((resolve, reject) => {
      const tx = db.transaction(IDB_STORE_JOURNAL, 'readwrite');
      const store = tx.objectStore(IDB_STORE_JOURNAL);
      for (const seq of sequences) {
        store.delete(seq);
      }
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(new Error('Transaction aborted'));
    });
  } finally {
    db.close();
  }
}
export async function countJournalEntries(taskID: string): Promise<number> {
  const db = await openDb();
  try {
    return await new Promise<number>((resolve, reject) => {
      const tx = db.transaction(IDB_STORE_JOURNAL, 'readonly');
      const store = tx.objectStore(IDB_STORE_JOURNAL);
      const index = store.index('taskID');
      const request = index.count(IDBKeyRange.only(taskID));
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  } finally {
    db.close();
  }
}
async function openDb(): Promise<IDBDatabase> {
  await initDB();
  return new Promise((resolve, reject) => {
    const request = globalThis.indexedDB.open(DB_NAME, DB_VERSION);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}